import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Navigation } from "../components/navigation";
import { Contact } from "../components/contact";
import JsonData from "../data/data.json";
import { APP_STORE_URLS, DEEP_LINK_SCHEME, APP_OPEN_TIMEOUT } from "../config/appStores";

const SignupReferral = () => {
  const [searchParams] = useSearchParams();
  const [landingPageData, setLandingPageData] = useState({});
  const [deviceType, setDeviceType] = useState('unknown');
  const [referralCode, setReferralCode] = useState('');
  const [codeCopied, setCodeCopied] = useState(false);

  useEffect(() => {
    setLandingPageData(JsonData);
    
    // Capturar código de referência da URL
    const refCode = searchParams.get('ref');
    if (refCode) {
      setReferralCode(refCode);
      // Salvar no localStorage para uso futuro
      localStorage.setItem('coffeeInReferralCode', refCode);
    }
    
    // Detectar tipo de dispositivo
    const userAgent = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(userAgent)) {
      setDeviceType('ios');
    } else if (/android/.test(userAgent)) {
      setDeviceType('android');
    } else {
      setDeviceType('desktop');
    }
  }, [searchParams]);

  const handleTryApp = () => {
    // Tentar abrir o app com o código de referência
    const appUrl = `${DEEP_LINK_SCHEME}://signup?ref=${referralCode}`;
    const fallbackUrl = deviceType === 'ios' 
      ? APP_STORE_URLS.ios
      : APP_STORE_URLS.android;
    
    window.location.href = appUrl;
    
    setTimeout(() => {
      window.location.href = fallbackUrl;
    }, APP_OPEN_TIMEOUT);
  };

  const copyReferralCode = () => {
    navigator.clipboard.writeText(referralCode);
    setCodeCopied(true);
    setTimeout(() => setCodeCopied(false), 2000);
  };

  return (
    <div>
      <Navigation />
      
      {/* Seção de Código de Referência */}
      {referralCode && (
        <div id="referral-code-section" className="text-center">
          <div className="container">
            <div className="referral-code-card">
              <h2>Você foi convidado!</h2>
              <p className="code-label">Seu código de indicação:</p>
              <div className="code-container">
                <span className="code">{referralCode}</span>
                <button className="copy-btn" onClick={copyReferralCode}>
                  {codeCopied ? '✓ Copiado!' : '📋 Copiar'}
                </button>
              </div>
              <p className="code-info">
                Use este código ao se cadastrar para ganhar benefícios especiais!
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Seção de Download por Plataforma */}
      <div id="download-platforms" className="text-center">
        <div className="container">
          <div className="section-title">
            <h2>Escolha sua plataforma</h2>
            <p>Disponível para iOS e Android</p>
          </div>
          
          <div className="download-buttons-container">
            {deviceType === 'ios' && (
              <div className="download-section">
                <h3>Para iPhone e iPad</h3>
                <a 
                  href={APP_STORE_URLS.ios}
                  className="download-btn ios-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/img/GetAtAppStore.svg" alt="Baixar na App Store" />
                </a>
                <p className="download-info">
                  Requer iOS 13.0 ou superior
                </p>
              </div>
            )}
            
            {deviceType === 'android' && (
              <div className="download-section">
                <h3>Para Android</h3>
                <a 
                  href={APP_STORE_URLS.android}
                  className="download-btn android-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/img/GetItOnGooglePlay.svg" alt="Disponível no Google Play" />
                </a>
                <p className="download-info">
                  Requer Android 7.0 ou superior
                </p>
              </div>
            )}
            
            {deviceType === 'desktop' && (
              <div className="desktop-download-section">
                <h3>Escolha sua plataforma</h3>
                <div className="platform-options">
                  <div className="platform-option">
                    <h4>iOS</h4>
                    <p>iPhone e iPad</p>
                    <a 
                      href={APP_STORE_URLS.ios}
                      className="download-btn ios-btn"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/img/GetAtAppStore.svg" alt="Baixar na App Store" />
                    </a>
                  </div>
                  
                  <div className="platform-option">
                    <h4>Android</h4>
                    <p>Smartphones e tablets</p>
                    <a 
                      href={APP_STORE_URLS.android}
                      className="download-btn android-btn"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="/img/GetItOnGooglePlay.svg" alt="Disponível no Google Play" />
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Seção para usuários que já têm o app */}
          {referralCode && (
            <div className="try-app-section">
              <div className="try-app-content">
                <h3>Já tem o app?</h3>
                <p>Abra o CoffeeIn Club diretamente no seu dispositivo</p>
                <button className="try-app-btn" onClick={handleTryApp}>
                  Abrir no app
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <Contact data={landingPageData.Contact} />
      
      <style jsx>{`
        #referral-code-section {
          padding: 80px 0 40px 0;
          background: white;
        }
        
        .referral-code-card {
          background: linear-gradient(135deg, #5d4037 0%, #8d6e63 100%);
          border-radius: 15px;
          padding: 50px 40px;
          max-width: 700px;
          margin: 0 auto;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
          color: white;
        }
        
        .referral-code-card h2 {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 30px;
          color: white;
        }
        
        .code-label {
          color: rgba(255, 255, 255, 0.9);
          font-size: 1.1rem;
          margin-bottom: 20px;
          font-weight: 600;
        }
        
        .code-container {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 15px;
          margin-bottom: 25px;
          flex-wrap: wrap;
        }
        
        .code {
          font-size: 2.5rem;
          font-weight: 700;
          color: white;
          letter-spacing: 3px;
          font-family: monospace;
          background: rgba(255, 255, 255, 0.2);
          padding: 15px 25px;
          border-radius: 10px;
        }
        
        .copy-btn {
          background: white;
          color: #5d4037;
          border: none;
          padding: 12px 20px;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .copy-btn:hover {
          background: rgba(255, 255, 255, 0.9);
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
        }
        
        .code-info {
          color: rgba(255, 255, 255, 0.9);
          font-size: 1rem;
          margin: 0;
        }
        
        #download-platforms {
          padding: 80px 0;
          background: white;
        }
        
        .download-buttons-container {
          margin-top: 50px;
        }
        
        .download-section {
          margin: 40px 0;
        }
        
        .download-section h3 {
          color: #5d4037;
          margin-bottom: 30px;
          font-weight: 600;
        }
        
        .download-btn {
          display: inline-block;
          margin: 20px 0;
          transition: all 0.3s ease;
        }
        
        .download-btn:hover {
          transform: translateY(-3px);
        }
        
        .download-btn img {
          height: 60px;
          width: auto;
        }
        
        .download-info {
          color: #666;
          font-size: 14px;
          margin-top: 10px;
        }
        
        .desktop-download-section h3 {
          color: #5d4037;
          margin-bottom: 40px;
          font-weight: 600;
        }
        
        .platform-options {
          display: flex;
          justify-content: center;
          gap: 40px;
          margin-top: 40px;
        }
        
        .platform-option {
          text-align: center;
          padding: 30px;
          background: white;
          border-radius: 15px;
          box-shadow: 0 5px 20px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
          min-width: 200px;
        }
        
        .platform-option:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.15);
        }
        
        .platform-icon {
          font-size: 3rem;
          margin-bottom: 15px;
        }
        
        .platform-option h4 {
          color: #5d4037;
          margin-bottom: 10px;
          font-weight: 600;
        }
        
        .platform-option p {
          color: #666;
          margin-bottom: 20px;
        }
        
        .try-app-section {
          margin-top: 60px;
          padding: 40px;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          border-radius: 15px;
        }
        
        .try-app-content h3 {
          color: #5d4037;
          margin-bottom: 15px;
          font-weight: 600;
        }
        
        .try-app-content p {
          color: #666;
          margin-bottom: 25px;
        }
        
        .try-app-btn {
          background: #5d4037;
          color: white;
          border: none;
          padding: 15px 30px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .try-app-btn:hover {
          background: #4a3429;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(93, 64, 55, 0.3);
        }
        
        .section-title h2 {
          color: #5d4037;
          margin-bottom: 20px;
          font-weight: 700;
        }
        
        .section-title p {
          color: #666;
          font-size: 18px;
          margin-bottom: 50px;
        }
        
        @media (max-width: 768px) {
          #referral-code-section {
            padding: 60px 0 30px 0;
          }
          
          .referral-code-card {
            padding: 40px 25px;
          }
          
          .referral-code-card h2 {
            font-size: 2rem;
          }
          
          .code {
            font-size: 2rem;
            padding: 12px 20px;
          }
          
          .code-container {
            flex-direction: column;
          }
          
          .copy-btn {
            width: 100%;
            max-width: 200px;
          }
          
          .platform-options {
            flex-direction: column;
            align-items: center;
            gap: 20px;
          }
          
          .platform-option {
            min-width: auto;
            width: 100%;
            max-width: 300px;
          }
        }
      `}</style>
    </div>
  );
};

export default SignupReferral;

